import React from "react";
import LabeledInput from "../components/LabeledInput";
import RichMessage from "../components/RichMessage";
import { useTranslation } from "react-i18next";

const SafeSignal = ({ register, errors, watch, control, validate, userData = {}, responseData = {} }) => {
  const { t } = useTranslation();
  const isEnrollmentRequired = Boolean(responseData?.style?.require_safesignal_enrollment);
  const isEnrolling = isEnrollmentRequired ? true : watch ? watch(`enrolling_in_safety`) : false;
  const custom_data = responseData?.safesignal?.custom_data;

  return (
    <div id="safesignal" data-cy="safesignal">
      {!isEnrollmentRequired && (
        <div className="field">
          <input type="checkbox" id={`enrolling_in_safety`} {...register(`enrolling_in_safety`)} />
          <label htmlFor={`enrolling_in_safety`}>{t("safesignal.enrolling_checkbox_label")}</label>
        </div>
      )}
      {isEnrolling && (
        <>
          <h2>{t("safesignal.enrollment_header")}</h2>

          <div className="summary">
            <RichMessage>{responseData.safesignal.instructions}</RichMessage>
          </div>

          <p className="ss_row ss_video">
            <video width="100%" controls>
              <source src="https://alertmedia-public.s3.us-west-1.amazonaws.com/starting-safety-monitoring-timer-session.mp4" type="video/mp4" />
              {t("safesignal.video_fallback")}
            </video>
          </p>
          {custom_data.required.length > 0 && (
            <>
              <h3>{t("safesignal.additional_required_info_header")}</h3>
              <div id="fields">
                {custom_data.required.map((field) => (
                  <div key={field.internal_name} className="field-wrapper">
                    <LabeledInput
                      key={field.internal_name}
                      fieldInfo={field}
                      validate={validate}
                      control={control}
                      register={register}
                      errors={errors}
                      prefix={field.is_extended ? "additionalData" : "user"}
                      userData={field.is_extended ? userData.additional_data : userData}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
          {custom_data.optional.length > 0 && (
            <>
              <h3>{t("safesignal.additional_info_header")}</h3>
              <div className="summary">
                <RichMessage>{responseData.safesignal.additional_information}</RichMessage>
              </div>
              <div id="fields">
                {custom_data.optional.map((field) => (
                  <div key={field.internal_name} className="field-wrapper">
                    <LabeledInput
                      key={field.internal_name}
                      fieldInfo={field}
                      validate={validate}
                      control={control}
                      register={register}
                      errors={errors}
                      prefix={field.is_extended ? "additionalData" : "user"}
                      userData={field.is_extended ? userData.additional_data : userData}
                    />
                  </div>
                ))}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default SafeSignal;
